import React from 'react';
import OuvrirFenetrePartenaireSansImg from '../../components/OuvrirFenetrePartenaireSansImg';
import OuvrirFenetrePartenaire from '../../components/OuvrirFenetrePartenaire';
import CartesTTVL from '../../images/CartesTTVL.jpg';
import CartesRegion from '../../images/CartesRegion.jpg';

const CartesContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Nos Cartes postales</h3>
            <p className="content-description">Voici un aperçu des cartes postales que vous trouverez dans notre boutique</p>
            <div className="product-grid">
                <div className="product-item">
                    <h4>Cartes du train touristique (TTVL)</h4>
                    <img src={CartesTTVL} alt="Cartes TTVL" className="product-image" />
                </div>
                <div className="product-item">
                    <h4>Cartes de la région</h4>
                    <img src={CartesRegion} alt="Cartes de la région" className="product-image" />
                </div>
            </div>
            {/* <div className="partner-section"> */}
            <div className="partner-section">
                <OuvrirFenetrePartenaireSansImg
                    sitePartenaire="https://www.yvesducourtioux.fr/"
                    texteBoutonPartenaire="Cartes de collection de la région : Yves Ducourtioux"
                />
                <OuvrirFenetrePartenaire 
                    imageUrl="/ImgPartenaires/CartesDucourtioux.jpg" 
                    sitePartenaire="https://www.yvesducourtioux.fr/"
                    // classPartenaire='partner-image'
                    classPartenaire='product-image'
                    altPartenaire='Cartes Ducourtioux'
                />
            </div>
        </div>
    );
};

export default CartesContent;
